import {
  AvailabilityTierUpdateRequestType,
  AvailabilityTierUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useAvailabilityTierUpdate = (availabilityTierId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: AvailabilityTierUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `availability-tiers/${availabilityTierId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as AvailabilityTierUpdateResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.AvailabilityTiers],
      });
    },
  });
};
